export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/arrayToObject.js
// module id = 3967
// module chunks = 25